import React, {useMemo, useState} from 'react';
import PropTypes from 'prop-types';

import {inventory} from '../../../../proptypes/inventory';
import InventoriesTable from './InventoriesTable';
import Box from '@mui/material/Box';
import AddIcon from '@mui/icons-material/Add';
import Fab from '@mui/material/Fab';
import InventoriesDialog from './InventoriesDialog';
import LazyLoading from '../../../../LazyLoading';

const styles = {
  fab: {
    float: 'right',
    mt: 2,
    '&.MuiButtonBase-root': {
      borderRadius: '100%',
      backgroundColor: 'secondary.main',
      mr: 1,
      '&:hover': {
        backgroundColor: 'primary.main',
      }
    },
    '&.Mui-disabled': {
      backgroundColor: '#d7d7d7'
    }
  }
};

const InventoriesMenu = ({
  minYear,
  maxYear,
  inventories,
  newInventories,
  plantingYear,
  onInventoryAdd,
  onInventoriesDelete,
  onInventoryUpdate
}) => {

  const [openInventoryDialog, setOpenInventoryDialog] = useState(false);

  const isLoading = useMemo(() => !inventories, [inventories]);

  return isLoading
    ? <LazyLoading isLoading={isLoading}/>
    : <Box>
      <InventoriesTable
        inventories={inventories}
        newInventories={newInventories}
        onInventoriesDelete={onInventoriesDelete}
        onInventoryUpdate={onInventoryUpdate}
      />
      <Fab sx={styles.fab} size='small' onClick={() => setOpenInventoryDialog(!openInventoryDialog)}>
        <AddIcon sx={{color: 'white'}}/>
      </Fab>
      <InventoriesDialog
        minYear={minYear}
        maxYear={maxYear}
        inventories={inventories}
        isInventoryDialogOpen={openInventoryDialog}
        plantingYear={plantingYear}
        onDialogClose={() => setOpenInventoryDialog(!openInventoryDialog)}
        onInventoryAdd={onInventoryAdd}
      />
    </Box>;
};

InventoriesMenu.propTypes = {
  minYear: PropTypes.number.isRequired,
  maxYear: PropTypes.number.isRequired,
  inventories: PropTypes.arrayOf(inventory),
  newInventories: PropTypes.arrayOf(inventory),
  plantingYear: PropTypes.number,
  onInventoryAdd: PropTypes.func.isRequired,
  onInventoryUpdate: PropTypes.func.isRequired,
  onInventoriesDelete: PropTypes.func.isRequired,
};

export default InventoriesMenu;